<template>
  <div class="container">
    <p class="mb-s tips-primary">
      <Icon type="android-alert"></Icon>
      投保前，請先詳細閱讀保單介紹與保單條款，確保您的權益
    </p>
    <div class="shadow-wrapper padding-m mb-m">
      <div class="mb-s prod-policies">
        <h2 class="mb-s">商品條款</h2>
         <div class="policies-list flex-sc dir-col">
          <a 
            v-for="(item,index) in prodPolicies"
            :href="item.url"
            v-text="item.title"
            target="_blank"
            download
          />
        </div>
      </div>
    </div>
    <Button
      class="btn-primary btn-m pull-right"
      @click="nextStep"
      v-text="'下一步'"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Icon, Checkbox, Button } from 'iview';

  export default {
    components: { Icon, Checkbox, Button },
    data() {
      return {
        
      }
    },
    computed: {
      ...mapState({
        prodPolicies: ({ checkout }) => checkout.quotes.prodPolicies
      })
    },
    methods: {
      nextStep() {
        this.$router.push({ 
          name: 'checkoutInfo',
          params: { current: 1 } 
        });
      }
    }
  }
</script>